import { render, staticRenderFns } from "./EditTicketDetailsModal.vue?vue&type=template&id=56b2f9e9&scoped=true&"
import script from "./EditTicketDetailsModal.vue?vue&type=script&lang=js&"
export * from "./EditTicketDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2f9e9",
  null
  
)

export default component.exports